<template>
  <validation-observer ref="observer">
    <tabs-layout :tabs="sections">
      <template v-slot:tabTitle="{ tab }">
        {{ tab.title }}
      </template>
      <template v-slot:content="{ tab }">
        <component
            :ref="tab.ref"
            :is="tab.component"
            :distribution="distribution"
            :editMode="editMode"
            :connectTariffPeriod="connectTariffPeriod"
            :internationalTariffPeriod="internationalTariffPeriod"
            class="p-3"
            @validated="e => $emit('validated', e)"
        />
      </template>
    </tabs-layout>
  </validation-observer>
</template>

<script>
import VPPDetails from "./VPPDetails.vue"
import VPPHistory from "./VPPHistory.vue"
import { ValidationObserver } from "vee-validate"
import { capitalize } from "lodash"

export default {
  name: "VPPSection",
  components: { ValidationObserver },
  props: {
    distribution: Object,
    editMode: Boolean,
    connectTariffPeriod: Boolean,
    internationalTariffPeriod: Boolean,
  },
  data () {
    return {
      sections: [
        {
          ref: "vpp",
          title: capitalize(this.$t("vpp")),
          component: VPPDetails,
          valid: true,
          lazy: false,
        },
        {
          ref: "vpp_history",
          title: capitalize(this.$t("vpp_history")),
          component: VPPHistory,
          valid: true
        }
      ]
    }
  },
  methods: {
    setErrors (errors) {
      this.$refs.vpp.setErrors(errors)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .card-header {
    background-color: #f9f9f9 !important;
    padding-top: 0 !important;
}
.p-3 {
    padding: 0 !important;
    background-color: #f9f9f9 !important;
}
.vpp-details {
    display: grid;
}
</style>
